defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlaysCardsSlider',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'Common/Framework/ScriptLibraries/Scripts/TinySlider',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlayCard'
  ],
  function (m, Utils, TinySlider, PlayCard) {
    const PlaysCardsSlider = {
      controller: function ({ controller, renderDelay }) {
        Object.assign(this, controller);

        this.clubPlays = this.gamesForSelectedGameType
         || this.clubModelFields().myOffersAndActivePlays();
        this.clubPlaysCount = this.clubPlays.length;

        this.showControls = !Utils.isMobile() && this.clubPlaysCount > 2;
        this.checkSliderType = m.prop(null);

        this.initSlider = ($element, isNew) => {
          if (!isNew) {
            const _sliderOptions = {
              container: '.play-together-plays-cards-slider__list-wrapper',
              center: true,
              loop: false,
              items: Math.max(this.clubPlaysCount, 3),
              slideBy: 1,
              mouseDrag: false,
              autoplay: false,
              autoplayButtonOutput: false,
              autoWidth: true,
              controls: this.showControls,
              controlsContainer: this.showControls ? '.play-together-plays-cards-slider__navigation' : false,
              nav: true,
              navPosition: 'bottom'
            };

            if (this.clubPlaysCount === 1) {
              _sliderOptions.nav = false;
              _sliderOptions.center = false;
              _sliderOptions.loop = false;
              _sliderOptions.autoWidth = true;
            }

            if (this.clubPlaysCount === 2) {
              const $slideItem = $element.querySelector('.play-together-play-card');

              _sliderOptions.loop = false;
              _sliderOptions.autoWidth = true;
              if (($slideItem.clientWidth * 2) > $element.clientWidth) {
                _sliderOptions.nav = true;
              } else {
                _sliderOptions.nav = false;
                _sliderOptions.center = false;
              }
            }

            this._initSlider = () => {
              this.slider = TinySlider(_sliderOptions);

              this.checkSliderType(() => {
                if (this.clubPlaysCount === 2 && !_sliderOptions.nav) {
                  $element.classList.add('play-together-plays-cards-slider__list-wrapper--with-space');
                  [...this.slider.getInfo().slideItems].forEach((sliderItem) => {
                    sliderItem.classList.add('tns-slide-active');
                  });
                }
              });

              const onChangeSlide = () => {
                const sliderInfo = this.slider.getInfo();
                setTimeout(() => {
                  if (_sliderOptions.nav) {
                    [...sliderInfo.slideItems].forEach((sliderItem) => {
                      sliderItem.classList.remove('tns-slide-active');
                    });
                    sliderInfo.slideItems[sliderInfo.index].classList.add('tns-slide-active');
                  }
                });
              };

              if (_sliderOptions.nav) {
                onChangeSlide();
                [...this.slider.getInfo().slideItems].forEach((sliderItem, index) => {
                  sliderItem.addEventListener('click', (event) => {
                    if (this.slider.getInfo().index !== index) {
                      event.preventDefault();

                      if (index > this.slider.getInfo().index) {
                        this.slider.goTo('next');
                      } else {
                        this.slider.goTo('prev');
                      }
                    }
                  });
                });

                this.slider.events.on('indexChanged', () => {
                  onChangeSlide();
                });
              }
            };

            if (renderDelay) {
              setTimeout(() => {
                this.slider.destroy();
                this._initSlider();
              }, renderDelay);
            }
            this._initSlider();
          }
        };
      },
      view: function (controller) {
        controller.checkSliderType()?.();
        return m('.play-together-plays-cards-slider',
          m('.play-together-plays-cards-slider__inner',
            {
              config: controller.initSlider
            },
            m('.play-together-plays-cards-slider__list-wrapper', controller.clubPlays.map(function (play) {
              return m(PlayCard, {
                controller: controller,
                play: play
              });
            })),
            controller.showControls ? m('.play-together-plays-cards-slider__navigation', [
              m('.play-together-plays-cards-slider__navigation-arrow.play-together-plays-cards-slider__navigation-arrow--left',
                m('svg.play-together-plays-cards-slider__navigation-arrow-icon',
                  m('use', {
                    href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#arrow'
                  })
                )
              ),
              m('.play-together-plays-cards-slider__navigation-arrow.play-together-plays-cards-slider__navigation-arrow--right',
                m('svg.play-together-plays-cards-slider__navigation-arrow-icon',
                  m('use', {
                    href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#arrow'
                  })
                )
              )
            ]) : null
          )
        );
      }
    };

    // Public functions:
    return PlaysCardsSlider;
  });
